import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Input, Space, Typography } from 'antd';
import { useTranslate } from '@tolgee/react';

type Props = {
  comment: string;
  onCommentChange: (comment: string) => void;
};

const DeclineForm: React.FC<Props> = ({ comment, onCommentChange }) => {
  const { t } = useTranslate();

  return (
    <Space
      direction='vertical'
      size={16}
      style={{ width: '100%', marginTop: 24 }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <InfoCircleOutlined style={{ color: '#4a7df5', fontSize: 18 }} />
        <Typography.Text
          style={{ color: '#1a3c34', fontWeight: 600, fontSize: 15 }}
        >
          {t('Please advise what happened')}
        </Typography.Text>
      </div>
      <Input.TextArea
        className='decline-form-text-area'
        value={comment}
        onChange={e => onCommentChange(e.target.value)}
        placeholder={t(
          'e.g. I was browsing the menu, the item I wanted was unavailable...',
        )}
        maxLength={500}
        showCount
        rows={4}
        style={{ borderRadius: 12, borderColor: '#e8ecef' }}
        styles={{}}
      />
    </Space>
  );
};

export default DeclineForm;
